import { AuthCookieService } from './auth'

export interface IParams {
  url: string
  method?: string
  headers?: {}
  body?: any
}

export const rest = async (params: IParams) => {
  const { url, method, headers, body } = params

  const req = {
    method: method || 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'X-Backoffice-Version': `${process.env.REACT_APP_VERSION}`,
      ...headers,
    },
    body,
  }

  const res = await fetch(url, req)
  return res
}

export const restWithToken = async (params: IParams) => {
  const { token } = AuthCookieService.getAuthInfo()
  return await rest({
    ...params,
    headers: {
      ...params.headers,
      Authorization: `Bearer ${token}`,
    },
  })
}

export const formatUrlWithParams = (url: string, params: any) => {
  const formattedUrl = Object.keys(params).reduce((acc, key) => acc.replace(`:${key}`, params[key]), url)
  return formattedUrl
}

export const formatUrlWithQueryParams = (url: string, params: any) => {
  const formattedUrl = Object.keys(params).reduce(
    (acc, key, index) => `${acc}${index === 0 ? '?' : '&'}${[key]}=${params[key]}`,
    url,
  )
  return formattedUrl
}
